import { fetcher } from "utils";

import { GetProductsSearchParams, GetProductsSearchV1Response } from "typings";

export const get__products__search = (params: GetProductsSearchParams): Promise<GetProductsSearchV1Response> =>
  fetcher.get("/api/v1/products/search", {
    ...params,
    ...(!params.page && { page: { number: 1, size: 100 } })
  });
